import React from "react";
import "./style.scss";
import BaseFormPage from "../../components/BaseFormPage";
import FormHeader from "../../components/FormHeader";
import RecoveryCodeForm from "./components/RecoveryCodeForm";
import { useTranslation } from "react-i18next";
import ROUTES from "../../utils/routes.js";
export default function RecoveryCodePage() {
  const { t } = useTranslation();
  return (
    <BaseFormPage backTo={ROUTES.LOGIN_PAGE}>
      <FormHeader title={t("recovery_page.recovery_title")} />
      <RecoveryCodeForm />
    </BaseFormPage>
  );
}
